<template>
  <div class="enroll-auth-page">
    <div class="bg-shape shape-a"></div>
    <div class="bg-shape shape-b"></div>
    <el-card class="auth-card">
      <template #header>
        <div class="card-header">
          <h2>自主招生注册</h2>
          <p>请先注册账号后填写报名信息</p>
        </div>
      </template>

      <el-form ref="formRef" :model="form" :rules="rules" label-position="top" @submit.prevent="handleRegister">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name" placeholder="请输入姓名" />
        </el-form-item>
        <el-form-item label="身份证号" prop="id_card">
          <el-input v-model="form.id_card" placeholder="请输入身份证号" />
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入手机号" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="form.password" type="password" show-password placeholder="至少6位" />
        </el-form-item>

        <el-button class="submit-btn" type="primary" :loading="loading" @click="handleRegister">
          注册
        </el-button>
        <el-button class="ghost-btn" @click="router.push('/enroll/login')">
          已有账号，去登录
        </el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { enrollmentStudentApi } from '@/api'

const router = useRouter()
const formRef = ref()
const loading = ref(false)
const form = reactive({
  name: '',
  id_card: '',
  phone: '',
  password: ''
})

const idCardRule = [
  { required: true, message: '请输入身份证号', trigger: 'blur' },
  {
    pattern: /^[1-9]\d{5}(18|19|20)?\d{2}(0[1-9]|1[0-2])([0-2][1-9]|10|20|30|31)\d{3}([0-9Xx])$/,
    message: '身份证号格式不正确',
    trigger: 'blur'
  }
]

const phoneRule = [
  { required: true, message: '请输入联系电话', trigger: 'blur' },
  {
    pattern: /^1[3-9]\d{9}$/,
    message: '手机号格式不正确',
    trigger: 'blur'
  }
]

const rules = {
  name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
  id_card: idCardRule,
  phone: phoneRule,
  password: [{ required: true, min: 6, message: '密码至少6位', trigger: 'blur' }]
}

const handleRegister = () => {
  formRef.value.validate(async (valid) => {
    if (!valid) return

    loading.value = true
    try {
      await enrollmentStudentApi.register(form)
      ElMessage.success('注册成功，请登录')
      router.replace('/enroll/login')
    } finally {
      loading.value = false
    }
  })
}
</script>

<style scoped>
.enroll-auth-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    radial-gradient(circle at 18% 16%, rgba(74, 222, 128, 0.16), transparent 28%),
    radial-gradient(circle at 82% 18%, rgba(56, 189, 248, 0.16), transparent 32%),
    linear-gradient(140deg, #f0fdf4 0%, #ecfeff 100%);
  padding: 20px;
  position: relative;
  overflow: hidden;
}

.auth-card {
  width: 100%;
  max-width: 500px;
  border-radius: 18px;
  border: 1px solid rgba(187, 247, 208, 0.8);
  box-shadow: 0 20px 45px rgba(22, 101, 52, 0.12);
  position: relative;
  z-index: 1;
}

.bg-shape {
  position: absolute;
  border-radius: 999px;
}

.shape-a {
  width: 260px;
  height: 260px;
  background: rgba(74, 222, 128, 0.15);
  top: -90px;
  left: -70px;
}

.shape-b {
  width: 280px;
  height: 280px;
  background: rgba(56, 189, 248, 0.13);
  right: -100px;
  bottom: -120px;
}

.card-header {
  text-align: center;
}

.card-header h2 {
  font-size: 26px;
  color: #14532d;
  letter-spacing: 0.4px;
}

.card-header p {
  color: #64748b;
  margin-top: 6px;
}

:deep(.auth-card .el-form-item__label) {
  font-weight: 600;
  color: #334155;
}

.submit-btn,
.ghost-btn {
  width: 100%;
  margin-top: 8px;
}
</style>
